import { render, staticRenderFns } from "./kb-list.vue?vue&type=template&id=51f34d58&scoped=true&"
import script from "./kb-list.vue?vue&type=script&lang=js&"
export * from "./kb-list.vue?vue&type=script&lang=js&"
import style0 from "./kb-list.vue?vue&type=style&index=0&id=51f34d58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f34d58",
  null
  
)

export default component.exports